/**
 * Admin Settings Hub.
 *
 * Organization configuration: business profile, products, locations,
 * number formats, work orders, sales settings, and role management.
 * Wraps the existing SettingsPage with admin navigation context.
 */

import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import SettingsPage from "@/pages/SettingsPage";

function AdminSettingsHub() {
  return (
    <div className="page-content space-y-6">
      <div className="flex items-start gap-4">
        <Link
          to="/admin"
          className="mt-1.5 text-[var(--text-tertiary)] hover:text-[var(--text-secondary)] transition-colors"
        >
          <ArrowLeft className="h-5 w-5" />
        </Link>
        <div>
          <h2 className="text-2xl font-bold text-[var(--text-primary)]">
            Settings
          </h2>
          <p className="mt-1 text-sm text-[var(--text-secondary)]">
            Organization profile, products, locations, and configuration.
          </p>
        </div>
      </div>

      <SettingsPage />
    </div>
  );
}

export default AdminSettingsHub;
